(() => {
  if (window.__drooperStoreAccountHeaderInstalled) return;
  window.__drooperStoreAccountHeaderInstalled = true;

  const ACCOUNT_URL = 'https://entertainment.drooper.co/account';
  const STATUS_URL = 'https://entertainment.drooper.co/api/account/header';
  const DROOPER_SITE_HOSTS = new Set([
    'drooper.co',
    'www.drooper.co',
    'shop.drooper.co',
    'store.drooper.co'
  ]);

  const avatarStyles = {
    'drooper-blue': '#304966',
    'drooper-plum': '#735572',
    'drooper-gold': '#b58a39',
    'drooper-green': '#4d755d',
    'drooper-silver': '#747b84'
  };

  function avatarArt(id) {
    if (id === 'drooper-plum') {
      return '<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M42 12c-13 3-21 14-21 27 0 7 3 13 8 17-13-2-23-13-23-27C6 13 19 2 34 2c3 0 6 0 8 1-2 3-2 6 0 9Z" fill="currentColor"/><circle cx="45" cy="24" r="4" fill="currentColor"/></svg>';
    }

    if (id === 'drooper-gold') {
      return '<svg viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="14" fill="currentColor"/><g stroke="currentColor" stroke-width="5" stroke-linecap="round"><path d="M32 4v9M32 51v9M4 32h9M51 32h9M12 12l7 7M45 45l7 7M52 12l-7 7M19 45l-7 7"/></g></svg>';
    }

    if (id === 'drooper-green') {
      return '<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M32 55V28" stroke="currentColor" stroke-width="6" stroke-linecap="round"/><path d="M31 29C17 29 10 20 10 9c13 0 21 7 21 20ZM34 31c2-14 11-21 23-20 0 12-8 20-23 20Z" fill="currentColor"/></svg>';
    }

    if (id === 'drooper-silver') {
      return '<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M17 47h31c7 0 12-5 12-11s-5-11-12-11h-2C44 15 37 9 28 9 17 9 10 17 9 28 4 30 2 34 2 39c0 5 6 8 15 8Z" fill="currentColor"/></svg>';
    }

    return '<svg viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="12" fill="currentColor"/><ellipse cx="32" cy="32" rx="24" ry="10" fill="none" stroke="currentColor" stroke-width="5" transform="rotate(-22 32 32)"/></svg>';
  }

  function installStyles() {
    if (document.getElementById('drooper-store-account-styles')) return;
    const style = document.createElement('style');
    style.id = 'drooper-store-account-styles';
    style.textContent = `
      .drooper-store-account-avatar {
        width: 2rem;
        height: 2rem;
        border-radius: 999px;
        display: grid;
        place-items: center;
        overflow: hidden;
        border: 1px solid rgba(17, 17, 17, 0.18);
        box-shadow: inset 0 1px 0 rgba(255,255,255,0.25), 0 1px 3px rgba(0,0,0,0.12);
      }
      .drooper-store-account-avatar svg {
        width: 66%;
        height: 66%;
        color: #fff;
      }
    `;
    document.head.appendChild(style);
  }

  function accountLinks() {
    return Array.from(document.querySelectorAll('[data-drooper-account-link]'));
  }

  function normalizeLinks() {
    accountLinks().forEach((link) => {
      link.href = ACCOUNT_URL;
    });
  }

  function desktopIconLink() {
    return document.querySelector('[data-drooper-account-icon]');
  }

  function restoreSignedOut(link) {
    if (!link) return;
    if (link.dataset.drooperAccountOriginalHtml) {
      link.innerHTML = link.dataset.drooperAccountOriginalHtml;
    }
    link.setAttribute('aria-label', 'Drooper Account');
  }

  function showSignedIn(link, account) {
    if (!link) return;
    if (!link.dataset.drooperAccountOriginalHtml) {
      link.dataset.drooperAccountOriginalHtml = link.innerHTML;
    }

    const avatarId = avatarStyles[account?.avatarId] ? account.avatarId : 'drooper-blue';
    const displayName = typeof account?.displayName === 'string' ? account.displayName.trim() : '';
    const label = displayName ? `Drooper Account — ${displayName}` : 'Drooper Account';

    link.innerHTML = `<span class="drooper-store-account-avatar" style="background:${avatarStyles[avatarId]}" aria-hidden="true">${avatarArt(avatarId)}</span>`;
    link.setAttribute('aria-label', label);
  }

  async function refresh() {
    installStyles();
    normalizeLinks();

    const iconLink = desktopIconLink();
    if (!iconLink) return;
    if (!iconLink.dataset.drooperAccountOriginalHtml) {
      iconLink.dataset.drooperAccountOriginalHtml = iconLink.innerHTML;
    }

    // A host-only SameSite session on entertainment.drooper.co is only usable
    // for same-site Drooper hosts. Separate Shopify root domains still link to
    // the central account page, but do not pretend to know session state.
    if (!DROOPER_SITE_HOSTS.has(window.location.hostname)) {
      restoreSignedOut(iconLink);
      return;
    }

    try {
      const response = await fetch(STATUS_URL, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        cache: 'no-store',
        headers: { accept: 'application/json' }
      });

      if (!response.ok) {
        restoreSignedOut(iconLink);
        return;
      }

      const result = await response.json();
      if (result?.signedIn && result.account) {
        showSignedIn(iconLink, result.account);
      } else {
        restoreSignedOut(iconLink);
      }
    } catch {
      restoreSignedOut(iconLink);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
